export enum AppNameEnum {
  CARFIX = 'CARFIX',
  CONNECT = 'CONNECT',
  FLEET = 'FLEET'
}
